import { render, staticRenderFns } from "./dynamic-field-configuration.vue?vue&type=template&id=edd9e88c&"
import script from "./dynamic-field-configuration.vue?vue&type=script&lang=js&"
export * from "./dynamic-field-configuration.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports